import { queryOptions, useQuery } from "@tanstack/react-query";
import { api } from "../apiClient";

export const getTuitionFees = () => {
  return api.get(`admin/tuition-fees`);
};

export const getTuitionFeesQueryOptions = () => {
  return queryOptions({
    queryKey: ["tuition-fees"],
    queryFn: () => getTuitionFees(),
  });
};

export const useTuitionFeesQuery = (queryConfig = {}) => {
  return useQuery({
    ...getTuitionFeesQueryOptions(),
    ...queryConfig,
  });
};
